<template>
  <div class="report-layout">
    <div class="report-main d-flex align-items-center justify-content-center" style="min-height: 80vh;">
      <div class="card p-4 text-center" style="border-radius: 12px; border: 1px solid #e9ecef; max-width: 480px; width: 100%; box-shadow: 0 4px 12px rgba(0,0,0,0.05);">
        <div class="card-body">
          <div class="mb-3 mx-auto" style="width: 75px; height: 75px; background-color: #fce4d6; border: 1px solid #f8a3a3; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 32px; color: #c00000;">
            <i class="fas fa-lock"></i>
          </div>
          <p class="text-secondary small mb-0">Bu hesabata daxil olmaq üçün keçərli bir token lazımdır.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
.report-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f8f9fa;
}
.report-main {
  flex: 1;
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  padding: 24px 16px;
}
</style>
